var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "file-preview-container" }, [
    _vm.loading
      ? _c("div", { staticClass: "preview-loading" }, [_vm._m(0)])
      : _vm.error
      ? _c(
          "div",
          { staticClass: "preview-error" },
          [
            _c("feather-icon", {
              attrs: { icon: "AlertCircleIcon", size: "24" }
            }),
            _c("div", { staticClass: "error-message" }, [
              _vm._v(_vm._s(_vm.error))
            ])
          ],
          1
        )
      : _c("div", { staticClass: "preview-content" }, [
          _vm.isImage
            ? _c("div", { staticClass: "image-preview" }, [
                _c("img", {
                  attrs: { src: _vm.previewUrl, alt: _vm.file.name },
                  on: { error: _vm.handleImageError }
                })
              ])
            : _vm.isPDF
            ? _c("div", { staticClass: "pdf-preview" }, [
                _c("iframe", {
                  attrs: { src: _vm.previewUrl, frameborder: "0" }
                })
              ])
            : _vm.isText
            ? _c("div", { staticClass: "text-preview" }, [
                _c("pre", [_vm._v(_vm._s(_vm.textContent))])
              ])
            : _vm.isVideo
            ? _c("div", { staticClass: "video-preview" }, [
                _c("video", { attrs: { controls: "" } }, [
                  _c("source", {
                    attrs: { src: _vm.previewUrl, type: _vm.file.mime_type }
                  }),
                  _vm._v(" Seu navegador não suporta o elemento de vídeo. ")
                ])
              ])
            : _vm.isAudio
            ? _c("div", { staticClass: "audio-preview" }, [
                _c("audio", { attrs: { controls: "" } }, [
                  _c("source", {
                    attrs: { src: _vm.previewUrl, type: _vm.file.mime_type }
                  }),
                  _vm._v(" Seu navegador não suporta o elemento de áudio. ")
                ])
              ])
            : _c(
                "div",
                { staticClass: "unsupported-preview" },
                [
                  _c("feather-icon", {
                    attrs: { icon: "FileIcon", size: "48" }
                  }),
                  _c("div", { staticClass: "unsupported-message" }, [
                    _vm._v(" Preview não disponível para este tipo de arquivo ")
                  ])
                ],
                1
              )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spinner-border text-primary", attrs: { role: "status" } },
      [
        _c("span", { staticClass: "sr-only" }, [
          _vm._v("Carregando preview...")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }